<script>

const defaultCardinality = {
  '': '1..1',
  NP: '0..0',
  M: '1..1',
  R: '1..1',
  O: '1..1',
  C: '1..1'
}

const cardinalityItems = [
  { cardinality: '', allowedConformance: [''] },
  { cardinality: '0..0', allowedConformance: ['', 'NP'] },
  { cardinality: '0..1', allowedConformance: ['', 'R', 'O', 'F', 'C'] },
  { cardinality: '0..*', allowedConformance: ['', 'R', 'O', 'F', 'C'] },
  { cardinality: '1..1', allowedConformance: ['', 'M', 'R', 'O', 'C'] },
  { cardinality: '1..*', allowedConformance: ['', 'M', 'R', 'O', 'C'] }
]

export default {
  methods: {
    getDefaultCardinality (conformance, cardinality) {
      const possibleCardinalities = this.getPossibleCardinalities(conformance)
      return !possibleCardinalities.includes(cardinality)
        ? defaultCardinality?.[conformance || '']
        : cardinality
    },

    getPossibleCardinalities (conformance) {
      return cardinalityItems
        .filter((entry) => entry.allowedConformance.includes(conformance || ''))
        .map((entry) => entry.cardinality)
    }
  }
}
</script>
